import React from 'react';
import { classNames, layoutClassNames } from '../atoms';
import type { LayoutClassNameProps } from '../atoms';

export interface ButtonToolbarProps extends React.HTMLAttributes<HTMLDivElement>, LayoutClassNameProps {}

const ButtonToolbar: React.FC<ButtonToolbarProps> = ({
  className,
  children,
  role = 'toolbar',
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  ...props
}) => (
  <div
    className={classNames(
      'btn-toolbar',
      layoutClassNames({
        margin,
        marginTop,
        marginEnd,
        marginBottom,
        marginStart,
        marginX,
        marginY,
        padding,
        paddingTop,
        paddingEnd,
        paddingBottom,
        paddingStart,
        paddingX,
        paddingY,
        textAlign,
      }),
      className,
    )}
    role={role}
    {...props}
  >
    {children}
  </div>
);

export default ButtonToolbar;
